const Joi = require('joi');

const envVarsSchema = Joi.object()
  .keys({
    NODE_ENV: Joi.string().valid('production', 'development', 'demo', 'test').required(),
    REACT_APP_BUSINESS_NAME: Joi.string().required().description('Business name is required'),
    REACT_APP_CLIENT_URL: Joi.string().allow('').default('localhost:3000'),
    REACT_APP_API_URL: Joi.string().allow('').default('').description('backend server url'),
    REACT_APP_LOGO_FILENAME: Joi.string().allow('').default('').description('logo url'),
    REACT_APP_USERS_PER_PAGE: Joi.number().default(10).description('number of users per page in users table'),
    REACT_APP_PROD_PAYPAL_CLIENT_ID: Joi.string().required().description('Prod Paypal client id'),
    REACT_APP_TEST_PAYPAL_CLIENT_ID: Joi.string().required().description('Test Paypal client id'),
    REACT_APP_PROD_PAYPAL_SUBSCRIPTION_ID: Joi.string().required().description('Prod Paypal subscription id'),
    REACT_APP_PROD_EXPERIMENT_PAYPAL_SUBSCRIPTION_ID: Joi.string().required().description('Prod Experiment Paypal subscription id'),
    REACT_APP_TEST_PAYPAL_SUBSCRIPTION_ID: Joi.string().required().description('Test Paypal subscription id'),
    REACT_APP_TEST_EXPERIMENT_PAYPAL_SUBSCRIPTION_ID: Joi.string().required().description('Test Experiment Paypal subscription id'),
    REACT_APP_PAYPAL_QUARTERLY_VARIANT1_PLAN_ID: Joi.string().description('Prod Paypal quarterly variant1 plan id ($59)'),
    REACT_APP_PAYPAL_QUARTERLY_VARIANT2_PLAN_ID: Joi.string().description('Prod Paypal quarterly variant2 plan id ($39)'),
    REACT_APP_PAYPAL_QUARTERLY_VARIANT1_SANDBOX_PLAN_ID: Joi.string().description('Sandbox Paypal quarterly variant1 plan id ($59)'),
    REACT_APP_PAYPAL_QUARTERLY_VARIANT2_SANDBOX_PLAN_ID: Joi.string().description('Sandbox Paypal quarterly variant2 plan id ($39)'),
    REACT_APP_GOOGLE_CLIENT_ID: Joi.string().description('Google OAuth client ID'),
  })
  .unknown();

const { value: envVars, error } = envVarsSchema.prefs({ errors: { label: 'key' } }).validate(process.env);

if (error) {
  throw new Error(`Config validation error: ${error.message}`);
}

export const config = {
  businessName: envVars.REACT_APP_BUSINESS_NAME,
  logoFilename: envVars.REACT_APP_LOGO_FILENAME === '' ? false : envVars.REACT_APP_LOGO_FILENAME,
  clientURL: envVars.NODE_ENV === 'production' ? envVars.REACT_APP_CLIENT_URL : 'http://localhost:3000',
  api: {
    url: envVars.NODE_ENV === 'production' ? envVars.REACT_APP_API_URL : '',
  },
  users: {
  	resultsPerPage: envVars.REACT_APP_USERS_PER_PAGE,
  },
  paypalClientId: envVars.NODE_ENV === 'production' ? envVars.REACT_APP_PROD_PAYPAL_CLIENT_ID : envVars.REACT_APP_TEST_PAYPAL_CLIENT_ID,
  paypalSubscriptionId: envVars.NODE_ENV === 'production' ? envVars.REACT_APP_PROD_PAYPAL_SUBSCRIPTION_ID : envVars.REACT_APP_TEST_PAYPAL_SUBSCRIPTION_ID,
  paypalSubscriptionIdExperiment: envVars.NODE_ENV === 'production' ? envVars.REACT_APP_PROD_EXPERIMENT_PAYPAL_SUBSCRIPTION_ID : envVars.REACT_APP_TEST_EXPERIMENT_PAYPAL_SUBSCRIPTION_ID,
  paypalSubscriptionPlans: {
    'control': envVars.NODE_ENV === 'production' ? envVars.REACT_APP_PAYPAL_SUBSCRIPTION_PLAN_ID_CONTROL : envVars.REACT_APP_PAYPAL_SUBSCRIPTION_PLAN_ID_SANDBOX_CONTROL,
    'variant1': envVars.NODE_ENV === 'production' ? envVars.REACT_APP_PAYPAL_SUBSCRIPTION_PLAN_ID_VARIANT1 : envVars.REACT_APP_PAYPAL_SUBSCRIPTION_PLAN_ID_SANDBOX_VARIANT1,
    'variant2': envVars.NODE_ENV === 'production' ? envVars.REACT_APP_PAYPAL_SUBSCRIPTION_PLAN_ID_VARIANT2 : envVars.REACT_APP_PAYPAL_SUBSCRIPTION_PLAN_ID_SANDBOX_VARIANT2,
    'quarterly_variant1': envVars.NODE_ENV === 'production' ? envVars.REACT_APP_PAYPAL_QUARTERLY_VARIANT1_PLAN_ID : envVars.REACT_APP_PAYPAL_QUARTERLY_VARIANT1_SANDBOX_PLAN_ID,
    'quarterly_variant2': envVars.NODE_ENV === 'production' ? envVars.REACT_APP_PAYPAL_QUARTERLY_VARIANT2_PLAN_ID : envVars.REACT_APP_PAYPAL_QUARTERLY_VARIANT2_SANDBOX_PLAN_ID,
  },
  google: {
    clientId: envVars.REACT_APP_GOOGLE_CLIENT_ID,
  },
};
